import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=68b2c5f2"
var script = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=68b2c5f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports